import { render, staticRenderFns } from "./AddProd.vue?vue&type=template&id=19bdfac3"
import script from "./AddProd.vue?vue&type=script&lang=js"
export * from "./AddProd.vue?vue&type=script&lang=js"
import style0 from "./AddProd.vue?vue&type=style&index=0&id=19bdfac3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports